/* tslint:disable */
/* eslint-disable */

/**
 * - 1: DraftFromGodam
 * - 10: Editing
 * - 20: ReadyToAuthorize
 * - 30: AuthorizationSuspended
 * - 40: Authorized
 * - 50: OrderCreated
 * - 60: OrderSent
 * - 70: OrderOverTollerance
 * - 80: OrderAccounted
 * - 90: OrderPayable
 * - 95: DueDateEmitted
 * - 100: Closed
 */
export enum OrderRequestStateEnum {
  $1 = 1,
  $10 = 10,
  $20 = 20,
  $30 = 30,
  $40 = 40,
  $50 = 50,
  $60 = 60,
  $70 = 70,
  $80 = 80,
  $90 = 90,
  $95 = 95,
  $100 = 100,
}
